var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',{attrs:{"separator":">"}},_vm._l((_vm.items),function(f){return _c('BreadcrumbItem',{key:f.name,attrs:{"to":{
      name: f.name,
      query: _vm.$route.meta.query ? _vm.$route.query : '',
      params: { reload: true }
    }}},[_vm._v(_vm._s(f.title))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }